/* unplugin-vue-components disabled */import { render } from "./contact-us.vue?vue&type=template&id=6032fb80&scoped=true"
const script = {}

import "./contact-us.vue?vue&type=style&index=0&id=6032fb80&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6032fb80"]])

export default __exports__